import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    DUPLICATE_INTERNAL_BANNER,
    DuplicateInternalBanner
} from '../../../actions/bannersEdit/internal/duplicateInternalBanner';
import {
    DuplicateInternalBannerImage,
    duplicateInternalBannerImageAction
} from '../../../actions/imageEditor/internal/duplicateInternalBannerImage';
import { selectEditedInternalBannerTemplateResources } from '../../../selectors/internalBannerEdit/internalBannerEdit';
import { EpicDeps } from '../../../service/StoreFactory';
import { GdResourceType } from '../../../typings/graphql-grid';
import { State } from '../../../typings/state';

type EpicActions = DuplicateInternalBannerImage;

const getDuplicateInternalBannersActions = (state: State, action: DuplicateInternalBanner): EpicActions[] => {
    const resources = selectEditedInternalBannerTemplateResources(state.editInternalBanners, action.bannerId);

    return (resources || []).reduce<EpicActions[]>((acc, resource) => {
        if (resource.type === GdResourceType.IMAGE) {
            acc.push(duplicateInternalBannerImageAction(action.bannerId, action.newBannerId, resource.id));
        }

        return acc;
    }, []);
};

export const duplicateInternalBannerEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(DUPLICATE_INTERNAL_BANNER),
        mergeMap(
            (action: DuplicateInternalBanner): Observable<EpicActions> => {
                return of(...getDuplicateInternalBannersActions(store$.value, action));
            }
        )
    );
};
